import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';

const routes: RouteRecordRaw[] = [
	{
		path: 'company-need',
		name: ROUTES.APP.COMPANY_NEED._ROOT,
		component: () => import('./views/Layout.vue'),
		redirect: { name: ROUTES.APP.COMPANY_NEED.LIST },
		children: [
			{
				path: 'list',
				name: ROUTES.APP.COMPANY_NEED.LIST,
				component: () => import('./views/List.vue'),
			},
			{
				path: 'archived-list',
				name: ROUTES.APP.COMPANY_NEED.ARCHIVED_LIST,
				component: () => import('./views/ArchivedList.vue'),
			},
			{
				path: 'missions',
				name: ROUTES.APP.COMPANY_NEED.MISSIONS,
				component: () => import('./views/MissionsList.vue'),
			},
			{
				path: 'job-offers',
				name: ROUTES.APP.COMPANY_NEED.JOB_OFFERS,
				component: () => import('./views/JobOffersList.vue'),
			},
			{
				path: ':companyNeedId',
				name: ROUTES.APP.COMPANY_NEED.DETAIL._ROOT,
				component: () => import('./views/details/Layout.vue'),
				redirect: { name: ROUTES.APP.COMPANY_NEED.DETAIL.MATCHING },
				children: [
					{
						path: 'matching',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.MATCHING,
						component: () => import('./views/details/matching/Matching.vue'),
					},
					{
						path: 'candidates',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.CANDIDATES,
						component: () =>
							import('./views/details/candidates/Candidates.vue'),
					},
					{
						path: 'missions',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.MISSIONS,
						component: () => import('./views/details/missions/Mission.vue'),
					},
					{
						path: 'recruitment',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.RECRUITMENT,
						component: () =>
							import('./views/details/recruitment/Recruitment.vue'),
					},
					{
						path: 'pool',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.POOL,
						component: () => import('./views/details/pool/Pool.vue'),
					},
					{
						path: 'rejected-profiles',
						name: ROUTES.APP.COMPANY_NEED.DETAIL.REJECTED_PROFILES,
						component: () =>
							import('./views/details/rejected-profiles/RejectedProfiles.vue'),
					},
				],
			},
		],
	},
];

export default routes;
